import { Box, Input, Stack, Typography } from "@mui/material";
import Dropzone from "react-dropzone";
import { useEffect, useState } from "react";
import { Upload } from "@mui/icons-material";

export default function WushFileUploader({ handleFileUpload }) {
  const [files, setFiles] = useState([]);

  const handleFileChange = (files) => {
    setFiles(files);
  };

  useEffect(() => {
    if(files.length > 0) {
      handleFileUpload(files[0]);
    }
  }, [files]);

  return (
    <Stack>
      <Dropzone
        accept={{
          'image/png': 'image/png',
          'image/jpeg': 'image/jpeg',
        }}
        onDrop={handleFileChange}
        maxFiles={5}
      >
        {({getRootProps, getInputProps}) => (
          <Box
            {...getRootProps()}
          >
            <Input {...getInputProps()} />
            <Box
              py="10px"
              bgcolor="#f7f7f7"
              border="1px dashed grey"
              borderRadius="5px"
              textAlign="center"
              sx={{
                cursor: "pointer"
              }}
            >
              <Typography variant="body1">
                Drag files here or click to upload
              </Typography>
              <Stack textAlign="center">
                <Upload sx={{ mx: 'auto' }} />
              </Stack>
            </Box>
          </Box>
        )}
      </Dropzone>
    </Stack>
  );
}